import { Suspense } from 'react'
import { Navigate, Outlet, Routes, Route } from 'react-router-dom'

// config
import { Path, Params } from '@/config'
// components
import { AppLayout, SuspenseContentFallback } from '@/components'
// utils
import { importsLazy } from '@/utils'
// pages
const { ChartsPage } = importsLazy(() => import('@/pages'), 'ChartsPage')
const { FeedPage } = importsLazy(() => import('@/pages'), 'FeedPage')
const { LibraryPage } = importsLazy(() => import('@/pages'), 'LibraryPage')
const { NotificationsPage } = importsLazy(() => import('@/pages'), 'NotificationsPage')
const { NotificationsNotificationPage } = importsLazy(
  () => import('@/pages'),
  'NotificationsNotificationPage',
)
const { PostPage } = importsLazy(() => import('@/pages'), 'PostPage')
const { ProfilePage } = importsLazy(() => import('@/pages'), 'ProfilePage')
const { StudioCreatePostPage } = importsLazy(
  () => import('@/pages'),
  'StudioCreatePostPage',
)
const { StudioCreateTrackPage } = importsLazy(
  () => import('@/pages'),
  'StudioCreateTrackPage',
)
const { StudioEditPostPage } = importsLazy(() => import('@/pages'), 'StudioEditPostPage')
const { StudioEditTrackPage } = importsLazy(
  () => import('@/pages'),
  'StudioEditTrackPage',
)
const { StudioPage } = importsLazy(() => import('@/pages'), 'StudioPage')
const { UserPage } = importsLazy(() => import('@/pages'), 'UserPage')

const App = () => (
  <AppLayout>
    <Suspense fallback={<SuspenseContentFallback position="fit" />}>
      <Outlet />
    </Suspense>
  </AppLayout>
)

export const artistRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      { path: Path.Library, element: <LibraryPage /> },
      { path: Path.Charts, element: <ChartsPage /> },
      {
        path: `${Path.Studio}/*`,
        element: (
          <Routes>
            <Route path="" element={<StudioPage />} />
            <Route
              path={`${Path.Post}/*`}
              element={
                <Routes>
                  <Route path="" element={<StudioCreatePostPage />} />
                  <Route path={`${Params.PostID}`} element={<StudioEditPostPage />} />
                  <Route path="*" element={<Navigate to="." />} />
                </Routes>
              }
            />
            <Route
              path={`${Path.Track}/*`}
              element={
                <Routes>
                  <Route path="" element={<StudioCreateTrackPage />} />
                  <Route path={`${Params.TrackID}`} element={<StudioEditTrackPage />} />
                  <Route path="*" element={<Navigate to="." />} />
                </Routes>
              }
            />
            <Route path="*" element={<Navigate to="." />} />
          </Routes>
        ),
      },
      { path: Path.Profile, element: <ProfilePage /> },
      {
        path: `${Path.Notifications}/*`,
        element: (
          <Routes>
            <Route path="" element={<NotificationsPage />} />
            <Route
              path={`${Path.Notification}/*`}
              element={
                <Routes>
                  <Route
                    path={`${Params.NotificationID}`}
                    element={<NotificationsNotificationPage />}
                  />
                  <Route path="*" element={<Navigate to="." />} />
                </Routes>
              }
            />
            <Route path="*" element={<Navigate to="." />} />
          </Routes>
        ),
      },
      {
        path: `${Path.User}/*`,
        element: (
          <Routes>
            <Route path={`${Params.UserID}`} element={<UserPage />} />
            <Route path="*" element={<Navigate to="." />} />
          </Routes>
        ),
      },
      {
        path: `${Path.Post}/*`,
        element: (
          <Routes>
            <Route path={`${Params.PostID}`} element={<PostPage />} />
            <Route path="*" element={<Navigate to="." />} />
          </Routes>
        ),
      },
      { path: Path.Feed, element: <FeedPage /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
]
